module.exports = "/_next/static/images/basket_mob-03b7411bd7f444d8bdff0a79e37e1cc2.svg";